// When the days toolbar (day count, AI Planner, "Space evenly") shows: for
// any walk there's a day to lay out on — even a single day's, which it can
// split — unless it's hidden for this viewer (window.plannerDayToolsHidden,
// see PlannerDayTools on the server).
export function dayToolbarVisible(state: { maxDay: number; hasMainLine: boolean; hiddenForViewer: boolean }): boolean {
  if (state.hiddenForViewer) return false;
  return state.maxDay >= 2 || state.hasMainLine;
}

// When the AI Planner can start: with the toolbar showing and a route to plan
// — it joins up whatever else needs it, so only a plan with no route stops it.
export function aiPlannerAvailable(toolbarVisible: boolean, spacingProblemKind?: string | null): boolean {
  return toolbarVisible && spacingProblemKind !== 'no-route';
}

// The day count the toolbar shows: a plan's first route has no day number
// until there's a second day, but it's still one day.
export function shownDayCount(maxDay: number): number {
  return Math.max(1, maxDay);
}
